import { render, staticRenderFns } from "./PostQuestion.vue?vue&type=template&id=839a4474&scoped=true"
import script from "./PostQuestion.vue?vue&type=script&lang=js"
export * from "./PostQuestion.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/radio-button.css?vue&type=style&index=0&id=839a4474&prod&scoped=true&lang=css&external"
import style1 from "./PostQuestion.vue?vue&type=style&index=1&id=839a4474&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "839a4474",
  null
  
)

export default component.exports